export const switchInviteTypeLabel = (inviteType) => {
    switch (inviteType) {
        case "SCREENING_CENTER_INVITE":
            return "Invito";
        case "INVITE":
            return "Invito";
        case "REMINDER":
            return "Sollecito";
        default:
            return inviteType
    }
}

export const switchInviteDesc = (invite) => {
    switch (invite.type) {
        case "INVITE":
            return "Candidatura spontanea";
        case "SCREENING_CENTER_INVITE":
        case "REMINDER":
            return "Invito da servizio screening";
        default:
            return invite.inviteDesc
    }
}
export const switchWithdrawalMethod = (withdrawalMethod) => {
    switch (withdrawalMethod) {
        case "SHIPPED":
            return "A domicilio"
        case "COLLECTION_CENTER":
            return "Centro di ritiro"
        default:
            return "Non definito"

    }
}
